angular.module('zc.core')
  .factory('ZcTag', ZcTag);

ZcTag.$inject = ['$location', '$state', '$window', 'Devise', 'Environment'];
function ZcTag($location, $state, $window, Devise, Environment) {
  const EVENT_PREFIX = ZC_CONFIG.ZC_TAG_EVENT_PREFIX || 'zc';
  const service = {};
  let environment;
  service.initialized = false;

  Environment.get().then(res => {
    environment = res;
  });

  service.initialize = function() {
    if(ZC_CONFIG.ZC_APIKEY && !service.initialized) {
      let zcTag = $(`
      <script type="text/javascript" src="${$location.protocol()}://f1.zenclerk.com/publish/${ZC_CONFIG.ZC_APIKEY}.js"></script>
      `);
      $('body').append(zcTag);
      service.initialized = true;
    }
  };

  service.sendParticularEvent = function(name, attributes) {
    if(angular.isUndefined(environment)) {
      return;
    }

    let userId;
    if(Devise.currentUser) userId = Devise.currentUser.id;

    attributes = _.merge(attributes || {}, { user_id: userId, state: $state.current.name });
    name = `${EVENT_PREFIX}:${name}`;

    // show log on dev/staging env so that it's easy to test
    if((environment === 'staging' || environment === 'development')) {
      console.log('[DEV] Would send particular event', name, attributes);
    }

    // do not allow sending anything else than plain objects (or undefineds)
    if(angular.isDefined(attributes) && !_.isPlainObject(attributes)) {
      console.warn('Tried to send non-object as particular event', attributes);
      return;
    }

    if(angular.isUndefined($window.__zc)) {
      return;
    }

    $window.__zc.ParticularEventController.send($window.__zc.socket, name, attributes);
  };

  return service;
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/zc_tag.service.js